import React from "react";
import PropTypes from "prop-types";
// import { Container, Row, Col } from "shards-react";

import { Layout } from "antd";
const { Footer } = Layout;

const MainFooter = ({ contained, menuItems, copyright }) => (
  // <footer className="main-footer d-flex p-2 px-3 bg-white border-top">
  <Footer style={{ textAlign: "center" }}>
    {/* <Row align="center"> */}
    {/* <Col md="12" align="center"> */}
    <span>{copyright}</span>
    {/* </Col> */}
    {/* </Row> */}
  </Footer>
  // </footer>
);

MainFooter.propTypes = {
  /**
   * Whether the content is contained, or not.
   */
  contained: PropTypes.bool,
  /**
   * The menu items array.
   */
  menuItems: PropTypes.array,
  /**
   * The copyright info.
   */
  copyright: PropTypes.string,
};

MainFooter.defaultProps = {
  contained: true,
  copyright: "Copyright © 2021 EL SEWEDY MY BENEFITS",
  menuItems: [],
};

export default MainFooter;
